import dashboard from "./dashboard.vue";

/**
 * insert image
 * Created by peak on 16/8/18.
 */
export default {
    name: "image",
    icon: "custom-icon image",
    i18n: "image",
    show: true,
    dashboard
}



// WEBPACK FOOTER //
// ./src/components/editor/src/modules/image/index.js